import { combineEpics } from "redux-observable";
import { epicAppsflyerCurrentLevel } from "./epics/epicAppsflyerCurrentLevel";
import { epicAppsflyerLevelAchieved } from "./epics/epicAppsflyerLevelAchieved";
import { epicAppsflyerLevelUp } from "./epics/epicAppsflyerLevelUp";
import { epicAppsflyerPurchase } from "./epics/epicAppsflyerPurchase";
import { epicAppsflyerTutorialCompletion } from "./epics/epicAppsflyerTutorialCompletion";
import { epicAppsflyerUpdate } from "./epics/epicAppsflyerUpdate";
export var epicAppsflyer = combineEpics(epicAppsflyerCurrentLevel, epicAppsflyerLevelUp, epicAppsflyerLevelAchieved, epicAppsflyerPurchase, epicAppsflyerTutorialCompletion, epicAppsflyerUpdate);



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/epicAppsflyer.ts
// module id = 1771
// module chunks = 3